import * as types from '../mutation-types'
import attendanceService from '../../services/attendances'

const state = {
    loading: false,
    errors: null,
    attendances: []
}

const actions = {
    getAll({ commit }, data) {
        commit(types.ATTENDANCE_LOADING, true)
        attendanceService.getAll(data).then(
            response => {

                commit(types.LOAD_ATTENDANCES, response.data)
                commit(types.ATTENDANCE_LOADING, false)
                commit(types.ATTENDANCE_FAILURE, null)
            },
            error => {
                commit(types.ATTENDANCE_FAILURE, error)
                commit(types.ATTENDANCE_LOADING, false)
            }
        )
    },
    add({ commit }, data) {

        commit(types.ATTENDANCE_LOADING, true)
        commit(types.ATTENDANCE_FAILURE, null)
        attendanceService.add(data).then(
            response => {
                //console.log('responseooo', response)

                //commit(types.ADD_ATTENDANCE, response.data)
                commit(types.ATTENDANCE_LOADING, false)

            },
            error => {
                commit(types.ATTENDANCE_FAILURE, error)
                commit(types.ATTENDANCE_LOADING, false)
            }
        )
    },
    set_as({commit},val){
      commit(types.SET_AS, val)
    }


}

const mutations = {
    [types.ADD_ATTENDANCE](state, payload) {
        state.attendances = payload;
    },
    [types.LOAD_ATTENDANCES](state, payload) {
        state.attendances = payload
    },

    [types.ATTENDANCE_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.ATTENDANCE_LOADING](state, payload) {
        state.loading = payload
    },
    [types.SET_AS](state, payload){
      state.attendances[payload.idx].s_attendance.status = payload.status
    }
}

const getters = {
    ATTENDANCES: state => {
        return state.attendances
    },

    ATTENDANCE_ERROR: state => {
        return state.errors
    },

    ATTENDANCE_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/attendances.js